import PartsDialog from '@/components/sections/service/parts/parts-dialog';
import PartsHoverCard from '@/components/sections/service/parts/parts-hover-card';
import PartsPophover from '@/components/sections/service/parts/parts-pophover';
import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';
import { useHover, useWindowSize } from '@/components/shared/utility/hooks';
import { IParts } from '@/types/shared/parts';

interface MaintenanceListTableBriefBodyTitleValueProps {
  label: string;
  partTooltipData?: IParts;
}

const REMARK_TEXT = '(อ่านหมายเหตุเพิ่มเติม)';

export const MaintenanceListTableBriefBodyTitleValue = (
  props: MaintenanceListTableBriefBodyTitleValueProps
) => {
  const windowSize = useWindowSize();
  const hover = useHover();
  const hasRemark = props.label.includes(REMARK_TEXT);
  const label = hasRemark ? props.label.replace(REMARK_TEXT, '') : props.label;
  return (
    <Flex
      alignItems="center"
      columnGap="2"
      css={{
        position: 'relative',
        padding: props.partTooltipData ? '$space-3 0' : undefined,
      }}
    >
      <Icon icon="check-circle" color="icon-green-light" size="sm" />
      <Text font="bold">{label}</Text>
      {!!hasRemark && <Text>{REMARK_TEXT}</Text>}
      {!!props.partTooltipData && (
        <Box
          position="relative"
          marginLeft="2"
          cursor="pointer"
          data-test="maintenance_parts_moreInfo"
        >
          {windowSize.width && windowSize.width < 1024 ? (
            <PartsDialog parts={props.partTooltipData} />
          ) : hover ? (
            <PartsHoverCard parts={props.partTooltipData} />
          ) : (
            <PartsPophover parts={props.partTooltipData} />
          )}
        </Box>
      )}
    </Flex>
  );
};

MaintenanceListTableBriefBodyTitleValue.displayName =
  'SectionMaintenanceListTableBriefBodyTitleValue';
